import { Injectable } from '@angular/core';
import { CancelCashOutRepository } from '@shared/core/repositories/cancel-cash-out/cancel-cash-out.repository';
import { ApiService } from '@nequi/design-system-lib/logic';
import { CancelCashOutRequestEntity, CancelCashOutResponseEntity } from '@shared/core/entities';
import { ApiHeaderGenerateService } from '@shared/services/api-header-generate/api-header-generate.service';
import { Response } from '@private/modules/cash-out-payment/core/entities/response.entity';


@Injectable()
export class CancelCashOutImplRepository implements CancelCashOutRepository {

  constructor(private readonly apiService: ApiService,
              private readonly apiHeaderGenerateService: ApiHeaderGenerateService) {
  }

  public async cancelTransaction(params: CancelCashOutRequestEntity): Promise<CancelCashOutResponseEntity> {
    const headers = this.apiHeaderGenerateService.generateAuthHeaders();
    const response = await this.apiService
      .put<Response<CancelCashOutResponseEntity>>('cashout/cancellation', params, { headers });
    return response.data;
  }

}
